import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorProbability = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m24 3 14.849 6.151L45 24l-6.151 14.849L24 45 9.151 38.849 3 24 9.151 9.151Zm.448 7.305a3.12 3.12 0 0 1 2.209.915l.142.142a3.126 3.126 0 0 1 0 4.417l-2.842 2.842 1.247 1.246-1.784 1.783-1.246-1.246-6.376 6.376a3.1 3.1 0 0 1-1.012.678 3.1 3.1 0 0 1-1.196.236 3.1 3.1 0 0 1-2.208-.914l-.143-.142a3.126 3.126 0 0 1 0-4.417l6.376-6.376-1.246-1.246 1.783-1.784 1.246 1.247 2.842-2.842a3.13 3.13 0 0 1 2.208-.915M24 26.6a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 1 0-5.2 0m7.8 7.8a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 1 0-5.2 0m-5.601 3.564 10.9-13-2.298-1.928-10.9 13Z"
	}), /* @__PURE__ */ _jsx("path", { d: "M12.965 23.946a.69.69 0 0 0-.199.483.67.67 0 0 0 .199.482l.144.144a.68.68 0 0 0 .744.147.7.7 0 0 0 .22-.148l5.542-5.543-1.108-1.106z" })]
});
export default SvgColorProbability;
